<pr-panel
  [clazz]="
    clazz +
    ' ' +
    (display ? display + (variant ? '_' + variant : '') + ' ' : '')
  "
>
  <ng-content></ng-content>
</pr-panel>
